export const buildAzureFederationMetadataUrl = (tenantId: string, appId: string): string =>
  `https://login.microsoftonline.com/${tenantId}/federationmetadata/2007-06/federationmetadata.xml?appid=${appId}`;

export const buildAzureIdpInitiatedUrl = (appId: string, tenantId: string): string =>
  `https://launcher.myapps.microsoft.com/api/signin/${appId}?tenantId=${tenantId}`;

export const buildAzureOidcDiscoveryUrl = (tenantId: string): string =>
  `https://login.microsoftonline.com/${tenantId}/v2.0/.well-known/openid_configuration`;

